import React from "react";
import '../Styles/MissionPage2.scss';
// import {Link} from "react-router-dom";

function MissionPage2() {

   return (
      <div className="missionPage2Content">
         
      </div>
   )
}
export default MissionPage2;